import linkifyHtml from 'linkify-html';

import lineBreaker from '../../utils/lineBreaker';
import Expander from '../Expander';
import Image from '../Image';

const MerchantBanner = ({ bannerUrl, merchantName, merchantLogoUrl }) => (
  <div className="banner">
    <Image
      fill
      alt="banner image"
      src={bannerUrl}
      sizes="(max-width: 768px) 100vw"
      className="merchant-banner"
    />
    <img alt={merchantName} className="logo" src={merchantLogoUrl} />
  </div>
);

const MerchantDetails = ({ merchantName, description, bannerUrl, merchantLogoUrl }) => (
  <div className="merchant-meta">
    <MerchantBanner
      bannerUrl={bannerUrl}
      merchantName={merchantName}
      merchantLogoUrl={merchantLogoUrl}
    />
    <h2 className="merchant-title">{merchantName}</h2>
    <Expander
      summary="About"
      details={
        <div
          dangerouslySetInnerHTML={{
            __html: lineBreaker(linkifyHtml(description)),
          }}
        />
      }
    />
  </div>
);

const TermsAndConditions = ({ tnc }) => (
  <div className="terms">
    <Expander
      summary="Terms and Conditions"
      active
      details={<small dangerouslySetInnerHTML={{ __html: lineBreaker(tnc) }} />}
    />
  </div>
);

export { MerchantBanner, MerchantDetails, TermsAndConditions };
